export function normalizeAccessRole(description) {
  const normalized = String(description || "").trim().toUpperCase();
  if (normalized === "ADMINISTRADOR" || normalized === "ADMINISTRATOR") {
    return "ADMIN";
  }
  return normalized || "";
}

export function isGlobalAdminRole(description) {
  return normalizeAccessRole(description) === "ADMIN";
}

export function isGlobalCompany(description) {
  const normalized = String(description || "").trim().toUpperCase();
  return (
    normalized === "ADMIN" ||
    normalized === "ADMINISTRADOR" ||
    normalized === "TODAS" ||
    normalized === "TODAS AS EMPRESAS"
  );
}

export function formatAccessRoleLabel(description) {
  if (isGlobalAdminRole(description)) {
    return "ADMIN (consulta global + telas da matriz)";
  }
  return description || "S/N";
}

export function getAccessRoleHint(description) {
  if (isGlobalAdminRole(description)) {
    return "Perfil ADMIN: consulta de todas as empresas. Telas/menus seguem a matriz de permissões.";
  }
  return "Telas/menus seguem a matriz de permissões do perfil. O alcance das consultas depende da empresa vinculada.";
}

export function getCompanyHint(roleDescription, companyDescription) {
  if (isGlobalAdminRole(roleDescription)) {
    return "Com perfil ADMIN, a empresa é só cadastro; consultas trazem CDHU, PRODESP e demais.";
  }
  if (isGlobalCompany(companyDescription)) {
    return "Empresa ADMIN/Administrador: consultas trazem todas as OS, independente do perfil.";
  }
  return `Consultas limitadas à empresa ${companyDescription || "selecionada"}.`;
}
